import Flex from 'components/Flex'
import ProductRowSummary from 'components/ProductRowSummary'
import Select from 'components/Select'
import TextButton from 'components/TextButton'
import { View } from 'components/View'
import { CART_PRODUCT_MODEL_KEY } from 'models/daos/cart-product/constants'
import {
  delCartProductAction,
  updateCartProductAction
} from 'modules/cart-products/actions'
import { getNameCurrencySelector } from 'modules/currencies/selectors'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import WithIntl from 'components/WithIntl'
import { rangeArrayUtil } from 'packages/src'

class CartProductComponent extends React.Component {
  constructor (props) {
    super(props)
    this.handleClickDelete = this.handleClickDelete.bind(this)
    this.handleChangeQuantity = this.handleChangeQuantity.bind(this)
  }

  handleChangeQuantity (event, quantity) {
    this.props.dispatch(
      updateCartProductAction(
        getIdReduxUtil(this.props.value),
        {
          quantity: parseInt(quantity, 10)
        }
      )
    )
  }

  handleClickDelete () {
    this.props.dispatch(
      delCartProductAction(
        getIdReduxUtil(this.props.value)
      )
    )
  }

  renderDeleteButton () {
    return (
      <div>
        <TextButton
          onClick={this.handleClickDelete}
          style={{
            textAlign: 'left'
          }}
          c='black'
          fs='smaller'
        >
          Delete
        </TextButton>
      </div>
    )
  }

  renderQuantitySelect () {
    const quantity = (
      getValueReduxUtil(this.props.value, CART_PRODUCT_MODEL_KEY.QUANTITY)
    )
    return (
      <Flex>
        <Select
          onChange={this.handleChangeQuantity}
          value={quantity}
        >
          {
            rangeArrayUtil(1, 10)
              .map((value) =>
                (
                  <option
                    key={value}
                    value={value}
                  >{value}
                  </option>
                )
              )
          }
        </Select>
      </Flex>
    )
  }

  render () {
    const cartProduct = this.props.value
    const product = (
      getValueReduxUtil(
        cartProduct,
        CART_PRODUCT_MODEL_KEY.PRODUCT
      )
    )
    return (
      <div
        style={{
          paddingBottom: STYLES_PADDING.SMALL,
          textAlign: 'left',
          width: '100%'
        }}
      >
        <ProductRowSummary
          currency={this.props.currencyName}
          data={(
            getValueReduxUtil(
              cartProduct, CART_PRODUCT_MODEL_KEY.DATA
            )
          )}
          product={product}
          price={(
            getValueReduxUtil(
              cartProduct, CART_PRODUCT_MODEL_KEY.PRICE
            )
          )}
          quantity={(
            getValueReduxUtil(
              cartProduct, CART_PRODUCT_MODEL_KEY.QUANTITY
            )
          )}
          size={ProductRowSummary.SIZE.BIGGER}
          onClickDelete={this.handleClickDelete}
        />
        <View
          row
          mt
          ac
        >
          {this.renderQuantitySelect()}
          {this.renderDeleteButton()}
        </View>
      </div>
    )
  }
}

CartProductComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired,
  currencyName: PropTypes.string.isRequired
}

const select = () => createSelector(
  getNameCurrencySelector(),
  (
    currencyName
  ) => (
    {
      currencyName
    }
  )
)

const CartProduct = WithIntl(connect(select)(CartProductComponent))

export default CartProduct
